import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { LoyalizationFeeInterface } from '../interfaces/loyalization-fee.interface';
import { Observable } from 'rxjs';

@Injectable()
export class LoyalizationService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.LOYALIZATION_API_URL;
  }

  getLoyalizationFee(): Observable<LoyalizationFeeInterface> {
    return this.http.get<LoyalizationFeeInterface>(`${this.url}/loyalization-fee`);
  }

  setLoyalizationFee(loyalizationFee: number) {
    return this.http.post(`${this.url}/loyalization-fee`, { loyalizationFee });
  }

  getLoyalizationPeriods(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}/loyalization-periods`);
  }

  createLoyalizationPeriods(periods: string[]): Observable<string[]> {
    return this.http.post<string[]>(`${this.url}/loyalization-periods`, periods);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalization.service.ts